import exportData from '../../../Services/exportData'

export default (options) => async (dispatch) => {

  dispatch(exportData(options))

}